<template lang="pug">
  p-check(class="p-switch" v-model="checked") Afficher les biens vendus
</template>

<script>
export default {
  props: {
    contractType: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      checked: false
    }
  },

  watch: {
    checked () {
      if (this.checked) {
        this.$store.commit('updateParams', { key: 'contract_type', value: 'vendus' })
      } else {
        this.$store.commit('updateParams', { key: 'contract_type', value: 'ventes' })
      }

      this.$store.dispatch('searchAccommodations')
    }
  },

  mounted () {
    this.checked = this.contractType === 'vendus'

    this.$nextTick(() => {
      this.$store.commit('updateReady', 'contractType')
    })
  }
}
</script>
